export default {
      id: "twitter-usage",
      viewBox: "0 0 24.351 19.775",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#twitter",
      toString: function () {
        return this.url;
      }
    }